__turbopack_context__.v({
  "container": "player-module-scss-module__iu54tW__container",
  "container--controls-hidden": "player-module-scss-module__iu54tW__container--controls-hidden",
  "container__poster": "player-module-scss-module__iu54tW__container__poster",
  "container__poster--hidden": "player-module-scss-module__iu54tW__container__poster--hidden",
  "container__recommendation-card-container": "player-module-scss-module__iu54tW__container__recommendation-card-container",
  "container__skeleton": "player-module-scss-module__iu54tW__container__skeleton",
});
